import { gql } from '@apollo/client';

export default gql`
  query getJourneySegment($bookingReference: String!, $journeySegmentId: String!) {
    getJourneySegment(bookingReference: $bookingReference, journeySegmentId: $journeySegmentId) {
      arrivalDatetime
      arrivalPlatform
      arrivalStationCode
      cancelDatetime
      cancelledRevision
      createdRevision
      departureDatetime
      departurePlatform
      departureStationCode
      id
      secondaryServiceName
      segmentId
      serviceName
    }
  }
`;
